import { Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100 relative overflow-hidden">
      {/* Background watermark */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none opacity-[0.03]">
        <span className="font-heading text-[280px] whitespace-nowrap">漫蛙</span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand column */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-2xl text-white mb-8">漫蛙</h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              海量免费漫画资源，热血、恋爱、悬疑、科幻等分类，支持夜间阅读模式。蛙蛙陪伴，一键搜索追更，享受极致阅读体验。
            </p>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">快速链接</h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">首页</Link>
              {categories.slice(0, 4).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap"
                >
                  {cat.name}漫画
                </Link>
              ))}
              <Link to="/about" className="text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">关注我们</h4>
            <div className="flex flex-col gap-3">
              <a href="#" className="flex items-center gap-2 text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap" rel="nofollow">
                <i className="ri-links-line text-base w-5 h-5 flex items-center justify-center"></i>
                新浪微博
              </a>
              <a href="#" className="flex items-center gap-2 text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap" rel="nofollow">
                <i className="ri-wechat-line text-base w-5 h-5 flex items-center justify-center"></i>
                微信公众号
              </a>
              <a href="#" className="flex items-center gap-2 text-sm text-foreground-400 hover:text-white transition-colors whitespace-nowrap" rel="nofollow">
                <i className="ri-movie-line text-base w-5 h-5 flex items-center justify-center"></i>
                ??
              </a>
            </div>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-sm font-medium text-white mb-4">订阅更新</h4>
            <p className="text-sm text-foreground-400 mb-4">获取最新漫画更新通知和独家福利</p>
            <form className="flex">
              <input
                type="email"
                name="email"
                placeholder="输入邮箱地址"
                className="flex-1 bg-foreground-800 text-sm text-foreground-100 placeholder-foreground-500 px-4 py-2.5 rounded-l-lg outline-none border border-foreground-700 focus:border-accent-500 transition-colors"
              />
              <button
                type="submit"
                className="bg-accent-500 text-white px-4 rounded-r-lg hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 漫蛙 Manwa. 保留所有权利。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors whitespace-nowrap">帮助中心</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}